<template>
  <section class="features mb-5 mt-5 bg-light">
    <div class="container text-center">
      <h2 class="mb-4 text-uppercase fw-bold text-primary">
        {{ $t('features.title') }}
      </h2>
      <div class="row justify-content-center">
        <div class="col-md-4 d-flex">
          <div class="feature-box shadow-sm p-4 w-100 animate__animated animate__fadeInLeft">
            <i class="fa fa-calendar icon text-primary"></i>
            <h5 class="fw-bold mt-3 text-primary">{{ $t('features.reliableSchedule') }}</h5>
            <p>{{ $t('features.reliableScheduleDesc') }}</p>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="feature-box shadow-sm p-4 w-100 animate__animated animate__fadeInUp">
            <i class="fa fa-shield icon text-primary"></i>
            <h5 class="fw-bold mt-3 text-primary">{{ $t('features.safeCrossing') }}</h5>
            <p>{{ $t('features.safeCrossingDesc') }}</p>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="feature-box shadow-sm p-4 w-100 animate__animated animate__fadeInRight">
            <i class="fa fa-ship icon text-primary"></i>
            <h5 class="fw-bold mt-3 text-primary">{{ $t('features.scenicJourney') }}</h5>
            <p>{{ $t('features.scenicJourneyDesc') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeaturesHome",
};
</script>

<style scoped>
/* Stilizare Titlu Features */
.features h2 {
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: 1.5rem;
}

/* Cardurile de caracteristici */
.feature-box {
  background: white;
  border-radius: 12px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 25px;
  min-height: 250px; /* Face ca toate cardurile să fie egale */
}

.feature-box:hover {
  transform: translateY(-5px);
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.12);
}

/* Iconițe */
.icon {
  font-size: 3rem;
  transition: color 0.3s ease-in-out;
}

.feature-box:hover .icon {
  color: #007bff; /* Albastru mai vizibil la hover */
}

/* Stilizare text */
.feature-box h5 {
  font-size: 1.2rem;
  color: #001f3f;
  margin-top: 15px;
}

.feature-box p {
  font-size: 1.05rem;
  color: #6c757d; /* Gri elegant */
  max-width: 300px;
  line-height: 1.6;
}
</style>
